import { render, staticRenderFns } from "./ServiceTypesDetail.vue?vue&type=template&id=bc7f8d22&"
import script from "./ServiceTypesDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceTypesDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypesDetail.vue?vue&type=style&index=0&id=bc7f8d22&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7f8d22')) {
      api.createRecord('bc7f8d22', component.options)
    } else {
      api.reload('bc7f8d22', component.options)
    }
    module.hot.accept("./ServiceTypesDetail.vue?vue&type=template&id=bc7f8d22&", function () {
      api.rerender('bc7f8d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServiceTypesDetail.vue"
export default component.exports